import { createContext, useState } from "react";

export const CollapsedContext = createContext();

export function CollapsedProvider({ children }) {
  const [collapsed, setCollapsed] = useState(false);

  const onCollapse = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <CollapsedContext.Provider value={{ collapsed, onCollapse }}>
      {children}
    </CollapsedContext.Provider>
  );
}
